export default __webpack_public_path__ + "static/media/circularity_icon.315592db.png";